import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { SocialMediaIcons } from '@/components/SocialMediaIcons';
import { Accordion } from '@/components/ui/accordion';
import { siteConfig } from '@/config/site.config';

export function ContactPage() {
  return (
    <div style={{ backgroundColor: 'var(--color-bg-primary)' }} className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-extrabold sm:text-4xl" style={{ color: 'var(--color-text-primary)' }}>
            Contacta con nosotras
          </h1>
          <p className="mt-4 text-lg" style={{ color: 'var(--color-text-secondary)' }}>
            Estamos aquí para resolver tus dudas y ayudarte en tu camino profesional
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div className="lg:col-span-1">
            <Card className="h-full">
              <CardContent className="p-8 flex flex-col h-full">
                <h2 className="text-2xl font-semibold mb-6" style={{ color: 'var(--color-text-primary)' }}>
                  Información de contacto
                </h2>

                <div className="space-y-8">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-primary-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium" style={{ color: 'var(--color-text-primary)' }}>Email</h3>
                      <p style={{ color: 'var(--color-text-secondary)' }}>hola@animacionesmia.com</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-primary-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Dirección</h3>
                      <p className="text-gray-800">Calle Santander 3, 2º Izda<br />Madrid, 28003, España</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-primary-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Horario de respuesta</h3>
                      <p className="text-gray-800">Lunes a Viernes<br />9:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200 flex-1 flex flex-col justify-center">
                  <h3 className="text-lg font-medium text-gray-900 mb-4 text-center">
                    Síguenos en redes sociales
                  </h3>
                  <div className="flex justify-center">
                    <SocialMediaIcons
                      socialMedia={{
                        linkedin: 'https://www.linkedin.com/company/mianimacion',
                        twitter: 'https://x.com/MIAnimacion',
                        instagram: 'https://www.instagram.com/mianimacion/',
                        website: 'https://animacionesmia.com'
                      }}
                      className="space-x-6"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Contact CTA — the form lives on the WildApricot site */}
          <div className="lg:col-span-2">
            <Card className="h-full">
              <CardContent className="p-8 flex flex-col items-center justify-center text-center h-full space-y-6">
                <h2 className="text-2xl font-semibold" style={{ color: 'var(--color-text-primary)' }}>
                  Envíanos un mensaje
                </h2>
                <p className="max-w-md" style={{ color: 'var(--color-text-secondary)' }}>
                  Rellena nuestro formulario de contacto y te responderemos lo antes posible. También
                  puedes escribirnos directamente a{' '}
                  <a href="mailto:hola@animacionesmia.com" className="text-red-600 hover:text-red-700 underline font-medium">
                    hola@animacionesmia.com
                  </a>.
                </p>
                <Button asChild size="lg">
                  <a href={siteConfig.wildApricot.contactUrl} target="_blank" rel="noopener noreferrer">
                    Abrir formulario de contacto
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16">
          <Card>
            <CardContent className="p-8">
              <h2 className="text-2xl font-semibold mb-8 text-center" style={{ color: 'var(--color-text-primary)' }}>
                Preguntas frecuentes
              </h2>

              <Accordion
                items={[
                  {
                    title: "¿Quién puede hacerse socia de MIA?",
                    content: "Cualquier persona que se identifique como mujer y trabaje o estudie en el ámbito de la animación o sectores afines (ilustración, videojuegos, VFX, producción audiovisual, etc.) puede unirse a nuestra red."
                  },
                  {
                    title: "¿Cómo me hago socia?",
                    content: (
                      <>
                        Solo tienes que rellenar el formulario de inscripción disponible en nuestra web y seguir los pasos indicados. Una vez validada la solicitud, recibirás un correo de bienvenida con toda la información.{' '}
                        <Link to="/membresia" className="text-red-600 hover:text-red-700 underline font-medium">
                          Únete a MIA
                        </Link>
                      </>
                    )
                  },
                  {
                    title: "¿Qué beneficios tengo como socia?",
                    content: "Acceso a una comunidad activa, participación en eventos y formaciones exclusivas, visibilidad profesional en nuestros canales, oportunidades de networking y colaboración, y posibilidad de participar en proyectos y comisiones de MIA."
                  },
                  {
                    title: "¿Ser socia tiene algún coste?",
                    content: (
                      <>
                        Sí, hay diferentes tipos de membresía. Te invitamos a consultar las diferentes opciones{' '}
                        <Link to="/membresia" className="text-red-600 hover:text-red-700 underline font-medium">
                          aquí
                        </Link>.
                      </>
                    )
                  },
                  {
                    title: "¿Puedo participar activamente en MIA?",
                    content: "Sí, animamos a todas las socias a involucrarse. Puedes formar parte de grupos de trabajo, proponer iniciativas, colaborar en eventos o participar en campañas de comunicación."
                  },
                  {
                    title: "¿Qué compromiso implica ser socia?",
                    content: "No existe una obligación formal de participación. Puedes involucrarte tanto como desees o simplemente seguir nuestras actividades y disfrutar de los beneficios de la red."
                  }
                ]}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
